import UserApi from '@/api/account/user'
import PermissionApi from '@/api/permission/'
import PrivateFormApi from '@/api/formPrivate/index.js'

import uiHelper from '@/helpers/ui'

export default {
  namespaced: true,

  state: {
    userBusinesses: [],
    userLocations: [],
    userPermissions: {},
    privateForms: [],
    publicForms: [],
    selectedBusinessId: '',
    selectedBusinessDetails: [],
    selectedLocation: null,
    // allUsers: [],
    dashboardStats: {},
    clientToken: ''
  },

  getters: {
    userBusinesses: state => state['userBusinesses'],
    userLocations: state => state['userLocations'],
    selectedBusinessId: state => state['selectedBusinessId'],
    selectedLocation: state => state['selectedLocation'],
    privateForms: state => state['privateForms'],
    publicForms: state => state['publicForms'],
    userPermissions: state => state['userPermissions'],
    dashboardStats: state => state['dashboardStats'],
    clientToken: state => state.clientToken,
    tableHeaders: state => {
      return state.privateForms[0].attributes.table_headers
    }
  },

  mutations: {
    setUserBusinesses(state, businesses) {
      state.userBusinesses = businesses
    },

    setUserLocations(state, locations) {
      state.userLocations = locations
    },

    setSelectedBusinessId(state, business) {
      state.selectedBusinessId = business
    },

    setSelectedLocation(state, location) {
      state.selectedLocation = location
    },

    setPermissions(state, permissions) {
      state.userPermissions = permissions
    },

    setClientToken(state, token) {
      state.clientToken = token
    },

    setPrivateForms(state, forms) {
      state.privateForms = forms
    },

    setPublicForms(state, forms) {
      state.publicForms = forms
    },

    // setAllUsers(state, users) {
    //   state.allUsers = users
    // },

    setDashboardStats(state, stats) {
      state.dashboardStats = stats
    },

    clearAuthData(state) {
      state.setUserBusinesses = []
      state.userLocations = []
      state.userPermissions = {}
      state.selectedBusinessId = ''
      state.selectedLocation = ''
    }
  },

  actions: {
    async getAllBusinesses({ commit }) {
      try {
        const {
          data: { payload: businesses }
        } = await UserApi.getAllBusinesses()

        if (Array.isArray(businesses)) {
          commit('setUserBusinesses', businesses)
        }
        return businesses
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },

    async getAllLocations({ commit }) {
      try {
        const response = await UserApi.getAllLocations()
        const locations = response.data.payload

        if (Array.isArray(locations)) {
          commit('setUserLocations', locations)
        }
        return locations
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },

    async setSelectedBusiness({ commit }, businessId) {
      try {
        await UserApi.setSelectedBusiness(businessId)

        commit('setSelectedBusinessId', businessId)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
    },

    async setActiveLocation({ commit }, location) {
      try {
        await UserApi.setActiveLocation(location.id)
        commit('setSelectedLocation', location)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        return false
      }
      return true
    },

    async getPermissions({ commit }, location) {
      try {
        const response = await UserApi.getPermissions(location.id)
        const { payload } = response.data

        commit('setSelectedLocation', location)
        commit('setPermissions', payload)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },

    async getMyPermissions({ commit }) {
      try {
        const response = await PermissionApi.getMyPermissions()
        const formAccess = response.data.payload.form_access
        const allForms = Object.keys(formAccess)
        commit('form/setSelectedFormId', allForms[0], { root: true })
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        throw error
      }
    },

    // async getAccountsByLocation({ getters, commit }) {
    //   try {
    //     const response = await PermissionApi.getAccountsByLocation(
    //       getters.selectedLocation.id
    //     )

    //     commit('setAllUsers', response.data.payload)
    //   } catch (error) {
    //     uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
    //   }
    // },

    async getDashboardStats({ commit }, formId) {
      let response
      try {
        response = await PrivateFormApi.getDashboardStats(formId)
        commit('setDashboardStats', response.data.payload)
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      }
      return response.data.payload
    },

    async createUnoappRespondent({ commit }) {
      try {
        const response = await PrivateFormApi.createUnoappRespondent()
        commit('setClientToken', response.data.payload.client_token)
        return response
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
        return null
      }
    }
  }
}
